const hideJobDisplayIfEmpty = () => {
    if(document.querySelector('.ume-job-counter__content')){
        const counterHeadline = document.querySelector('.ume-job-counter__content');
        const holder = document.querySelector('.ume-career-just-related');
        const finderHolder = document.querySelector('.ume-career-finder-holder');
        const prevHolder = finderHolder.previousElementSibling;
        let isEmpty = counterHeadline.getAttribute('data-hide-if-empty');
        if(isEmpty === 'hide' && holder !== null){
            holder.classList.add('d-none');
            holder.classList.remove('d-flex');
            finderHolder.classList.add('d-none');
            finderHolder.classList.remove('d-flex');
            if(prevHolder !== null && prevHolder.classList.contains('wp-block-ume-ume-custom-spacer')){
                prevHolder.classList.add('d-none');
            }
        }
    }
}
export default hideJobDisplayIfEmpty;